import Axios from '../utils/Axios';
import AsyncLocalStorage from '../utils/AsyncLocalStorage';

export type SalesType = {
  start_date: string;
  end_date: string;
};
export type SalesListType = {
  data_type: 'order';
  cancel_description: string;
  cancelled_at: string;
  com_discount_amount: number;
  completed_at: string;
  confirmed_at: string;
  delivery_address: string;
  delivery_completed_at: string;
  delivery_expected_at: string;
  delivery_started_at: string;
  delivery_tip: number;
  delivery_type: number;
  hotel_name: string;
  inquiry: string;
  order_id: string;
  order_seq: number;
  order_status: number;
  ordered_at: string;
  payment_status: number;
  pickup_name: string;
  prepared_at: string;
  store_discount_amount: number;
  store_name: string;
  total_amount_incl: number;
  total_amount_org: number;
  bill_number: string;
  delivery_address_detail: string;
  issuer_name: string;
  delivery_score: null | number;
  food_score: null | number;
  content: null | string;
  lang: number;
  room_tip: number;
  store_id: number;
};

export type LogListType = {
  data_type: 'log';
  PATH: null | string;
  action_name: string;
  area_name: string;
  area_number: number;
  created_at: string;
  hotel_name: string;
  name: string;
  number: number;
  params: string;
  params2: null | string;
  store_name: null | string;
  timestamp: string;
};
export type OrderType = {
  order_id: string;
};

const SalesController = {
  // knockknock매출현황
  getSalesList: async (oParams: SalesType) => {
    try {
      let sUrl = process.env.REACT_APP_API_KNOCKKNOCK_URL + '/admin/getKnockOrder';
      // let sUrl = 'https://ivid-ceo-api.ivid.co.kr/api' + '/admin/getKnockOrder';
      const response: any = await Axios.post(sUrl, oParams);
      return response;
    } catch (err) {
      let oErr: any = err;
      return {
        ok: false,
        msg: '[knockknock매출 현황 오류]' + oErr.toString(),
        data: undefined,
      };
    }
  },
  getOrderByOrderId: async (oParams: OrderType) => {
    try {
      let sUrl = process.env.REACT_APP_API_KNOCKKNOCK_URL + '/order/getOrderByOrderId';
      const response: any = await Axios.post(sUrl, oParams);
      return response;
    } catch (err) {
      let oErr: any = err;
      return {
        ok: false,
        msg: '[knockknock 상세 메뉴 오류]' + oErr.toString(),
        data: undefined,
      };
    }
  },
};

export default SalesController;
